module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/slideshow-1-4f056189784fd46b7b5d219b83702682.png";